<template>
  <div class="footer-index">
    <div class="fi-sec-1 inline-block">
      <div class="fi-logo1">
        <img src="img/uedc-logo.png"/>
      </div>
      <el-divider direction="vertical" class="divider-line1"></el-divider>
      <div class="fi-contact inline-block">
        <div class="fi-title1">专注集团设计服务12年</div>
        <div class="fi-title2">业务合作联系：<a href="mailto:netease_uedc@service.netease.com" target="_blank" class="gray-text">netease_uedc@service.netease.com</a></div>
      </div>
    </div>
    <div class="fi-sec-2 inline-block">
      <div class="fec2-col inline-block">
        <div><a href="http://dubhe.netease.com" target="_blank">天枢<span class="gray-text"> - 设计灵感</span></a></div>
        <div><a href="http://axure.yixin.im/#/home" target="_blank"><span style="font-weight: bold">DBOX</span><span class="gray-text"> - 设计协作</span></a></div>
      </div>
      <div class="fec2-col inline-block">
        <div><a href="/" target="_self">自助制图<span class="gray-text"> - 设计效率</span></a></div>
        <div><a href="http://uem.netease.com/app/app.html#/login" target="_blank">设计管理平台<span class="gray-text"> - 设计管理</span></a></div>
      </div>
    </div>
    <el-divider direction="vertical" class="divider-line2"></el-divider>
    <div class="fi-sec-3 inline-block">
        <a href="https://www.163yun.com/product/yz" class="fi-logo2"><img  src="img/logo-1.png"/></a>
        <div class="gray-text">AI抠图由人工智能部门提供</div>
    </div>
  </div>
</template>
<script>
    export default {
        data() {
            return {};
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.getData();
            },
            getData() {

            }
        }
    }
</script>
<style lang="scss">
  @import "footer-index.scss";
</style>